export const transformFileUploadResponseForOrder = (response) => {
  if (response && typeof response === "object" && response.fileData) {
    let base64Data = response.fileData;

    if (typeof base64Data === "string" && base64Data.includes(",")) {
      base64Data = base64Data.split(",")[1];
    }

    return {
      type: "image_upload",
      beluga_ready: true,
      processed_data: base64Data,
      file_ref: true,
      hasFileData: true,
      filename: response.filename,
      fileType: response.fileType,
      fileSize: response.fileSize,
    };
  }

  if (response && typeof response === "object") {
    return {
      question_type: "file_upload",
      file_ref: true,
      hasFileData: Boolean(
        response.hasFileData || response.filename || response.fileType
      ),
      filename: response.filename,
      fileType: response.fileType,
      fileSize: response.fileSize,
    };
  }

  return response;
};

export const buildOrderQuestionnaireAnswers = (questions = [], responses = {}) => {
  const questionById = new Map((questions || []).map((question) => [question.id, question]));

  return Object.entries(responses || {}).reduce((acc, [qId, response]) => {
    const question = questionById.get(qId);

    if (!question) {
      acc[qId] = response;
      return acc;
    }

    if (
      question.question_type === "personal_details" ||
      question.question_type === "shipping_address"
    ) {
      if (response && typeof response === "object") {
        const validSubIds = new Set((question.sub_questions || []).map((sq) => sq.id));
        Object.entries(response).forEach(([subQId, subResponse]) => {
          if (validSubIds.has(subQId)) {
            acc[subQId] = subResponse;
          }
        });
      }
      return acc;
    }

    if (question.question_type === "program_authentication_preview") {
      return acc;
    }

    if (question.question_type === "file_upload") {
      acc[qId] = transformFileUploadResponseForOrder(response);
      return acc;
    }

    acc[qId] = response;
    return acc;
  }, {});
};
